const accountingCareers = [

    {
        id: 1,
        slug: "accounting-intern-trainee",
        title: "Accounting Intern / Trainee",
        department: "Accounting and Bookkeeping",
        location: "Remote",
        datePosted: "2026-04-13",
        employmentType: "INTERN",
        applicantCountry: "IN",
        description: {
            responsibilities: [
                "Assist with transaction recording and data entry",
                "Support bank and credit card reconciliations",
                "Organize accounting documents and client records",
                "Assist in preparing working papers and schedules",
                "Support bookkeeping team during monthly close"
            ],

            skills: [
                "Basic accounting concepts",
                "Excel fundamentals",
                "Attention to detail",
                "Ability to follow structured processes"
            ],

            experience: [
                "0-1 year"
            ],

            education: [
                "Pursuing or recently completed Bachelor's degree in Accounting, Finance, or Commerce"
            ]
        }
    },
    {
        id: 2,
        slug: "junior-bookkeeper",
        title: "Junior Bookkeeper",
        department: "Accounting and Bookkeeping",
        location: "Remote",
        datePosted: "2026-04-13",
        employmentType: "FULL_TIME",
        applicantCountry: "IN",
        description: {
            responsibilities: [
                "Record daily financial transactions",
                "Categorize income and expenses",
                "Maintain general ledger entries",
                "Assist with bank and credit card reconciliations",
                "Support preparation of financial statements"
            ],

            skills: [
                "Accounting fundamentals",
                "Excel proficiency",
                "Familiarity with accounting software",
                "Accuracy in financial data entry"
            ],

            experience: [
                "1–2 years"
            ],

            education: [
                "Bachelor's degree in Accounting, Finance, or Commerce"
            ]
        }
    },
    {
        id: 3,
        slug: "bookkeeper",
        title: "Bookkeeper",
        department: "Accounting and Bookkeeping",
        location: "Remote",
        datePosted: "2026-04-13",
        employmentType: "FULL_TIME",
        applicantCountry: "IN",
        description: {
            responsibilities: [
                "Manage full bookkeeping cycle for assigned clients",
                "Maintain accounts payable and receivable",
                "Perform monthly bank and credit card reconciliations",
                "Prepare monthly financial reports",
                "Coordinate with clients to collect required documents"
            ],

            skills: [
                "Bookkeeping and ledger management",
                "Accounting software proficiency (QuickBooks, Xero)",
                "Financial record organization",
                "Client communication"
            ],

            experience: [
                "2–4 years"
            ],

            education: [
                "Bachelor's degree in Accounting, Finance, or Commerce",
                "Additional bookkeeping certifications preferred"
            ]
        }
    },
    {
        id: 4,
        slug: "senior-bookkeeper",
        title: "Senior Bookkeeper",
        department: "Accounting and Bookkeeping",
        location: "Remote",
        datePosted: "2026-04-13",
        employmentType: "FULL_TIME",
        applicantCountry: "IN",
        description: {
            responsibilities: [
                "Review bookkeeping work prepared by junior staff",
                "Manage monthly and quarterly close processes",
                "Prepare management reports for clients",
                "Handle complex reconciliations and corrections",
                "Support year-end reporting and tax preparation"
            ],

            skills: [
                "Advanced bookkeeping expertise",
                "Financial statement preparation",
                "Quality control and review skills",
                "Process management"
            ],

            experience: [
                "4-6 years"
            ],

            education: [
                "Bachelor's degree in Accounting, Finance, or Commerce",
                "Professional certification preferred (CPA / CA Inter / ACCA)"
            ]
        }
    },
    {
        id: 5,
        slug: "accounting-analyst",
        title: "Accounting Analyst",
        department: "Accounting and Bookkeeping",
        location: "Remote",
        datePosted: "2026-04-13",
        employmentType: "FULL_TIME",
        applicantCountry: "IN",
        description: {
            responsibilities: [
                "Prepare financial reports and variance analysis",
                "Maintain accruals and adjusting entries",
                "Support budgeting and forecasting activities",
                "Assist with audit preparation",
                "Analyze financial trends and performance"
            ],
            skills: [
                "Financial analysis",
                "Strong Excel and data analysis skills",
                "Understanding of accounting standards",
                "Analytical thinking"
            ],
            experience: ["3–6 years"],
            education: [
                "Bachelor's or Master's degree in Accounting, Finance, or Commerce",
                "CPA / CA Inter / ACCA preferred"
            ]
        }
    },

    {
        id: 6,
        slug: "senior-accountant",
        title: "Senior Accountant",
        department: "Accounting and Bookkeeping",
        location: "Remote",
        datePosted: "2026-04-13",
        employmentType: "FULL_TIME",
        applicantCountry: "IN",
        description: {
            responsibilities: [
                "Manage month-end and year-end closing processes",
                "Review financial statements and accounting schedules",
                "Supervise bookkeeping and accounting teams",
                "Ensure compliance with accounting standards",
                "Support audit and tax processes"
            ],
            skills: [
                "Financial reporting expertise",
                "Strong understanding of accounting principles",
                "Team supervision",
                "Problem solving"
            ],
            experience: ["5–8 years"],
            education: [
                "Bachelor's degree in Accounting, Finance, or Commerce",
                "CPA / CA / ACCA preferred"
            ]
        }
    }
];

export default accountingCareers;
